/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import ITiposClientes from './entidades/tiposClientes';
import ITiposClientesFiltros from './entidades/tiposClientesFiltros';

export default class ModeloTiposClientes {
    public consultarTiposClientes() {
        return manejadorRest<IRespuesta<ITiposClientes>>(
            () => negocio.get('TipoCliente/ConsultarListaTipoCliente'),
            true
        );
    }
    public consultarTiposClientesPorFiltro(tipoCliente: ITiposClientesFiltros) {
        return manejadorRest<IRespuesta<ITiposClientes>>(
            () => negocio.post('TipoCliente/ConsultarListaTipoClientePorFiltro', tipoCliente),
            true
        );
    }
    public crearTiposClientes(tiposClientes: ITiposClientes) {
        return manejadorRest<IRespuesta<ITiposClientes>>(
            () => negocio.post('TipoCliente/GuardarTipoCliente', tiposClientes),
            true
        );
    }
    public editarTiposClientes(tiposClientes: ITiposClientes) {
        return manejadorRest<IRespuesta<ITiposClientes>>(
            () => negocio.put('TipoCliente/EditarTipoCliente', tiposClientes),
            true
        );
    }
    public eliminarTiposClientes(tiposClientes: ITiposClientes) {
        return manejadorRest<IRespuesta<ITiposClientes>>(
            () => negocio.delete('TipoCliente/EliminarTipoCliente', tiposClientes),
            true
        );
    }
}
